import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, withModifiers as _withModifiers, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-717dd85e"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "h-full flex flex-col relative" }
const _hoisted_2 = {
  key: 0,
  class: "space-y-6 container__login"
}
const _hoisted_3 = { key: 0 }
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "modal__header" }, [
  /*#__PURE__*/_createElementVNode("h2", { "data-testid": "title" }, "Get started")
], -1))
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "mb-2" }, "Email", -1))
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "mb-2" }, "Password", -1))
const _hoisted_7 = { class: "my-4 flex justify-end" }
const _hoisted_8 = /*#__PURE__*/_createTextVNode("Forgot password?")
const _hoisted_9 = /*#__PURE__*/_createTextVNode(" Login ")
const _hoisted_10 = /*#__PURE__*/_createTextVNode(" Not registered yet? ")
const _hoisted_11 = { key: 0 }
const _hoisted_12 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, [
  /*#__PURE__*/_createElementVNode("p", { class: "my-4 or-dash" }, "Or")
], -1))
const _hoisted_13 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "font-bold text-black" }, "Login with Metamask", -1))
const _hoisted_14 = { key: 1 }
const _hoisted_15 = { key: 0 }
const _hoisted_16 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "container mx-auto" }, [
  /*#__PURE__*/_createElementVNode("h2", null, "Get started")
], -1))
const _hoisted_17 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "mb-2" }, "Email", -1))
const _hoisted_18 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "mb-2" }, "Password", -1))
const _hoisted_19 = /*#__PURE__*/_createTextVNode(" Login ")
const _hoisted_20 = /*#__PURE__*/_createTextVNode(" Not registered yet? ")
const _hoisted_21 = { key: 0 }
const _hoisted_22 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, [
  /*#__PURE__*/_createElementVNode("p", { class: "my-4 or-dash" }, "Or")
], -1))
const _hoisted_23 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "font-bold text-black" }, "Login with Metamask", -1))
const _hoisted_24 = { key: 1 }
const _hoisted_25 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "modal__header" }, [
  /*#__PURE__*/_createElementVNode("h2", null, "Receive NFTs")
], -1))
const _hoisted_26 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "mb-2" }, "Send NFTs to this wallet :", -1))
const _hoisted_27 = /*#__PURE__*/_createTextVNode(" Send ")
const _hoisted_28 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, [
  /*#__PURE__*/_createElementVNode("p", { class: "my-4 or-dash" }, "Or")
], -1))
const _hoisted_29 = { class: "space-y-6" }
const _hoisted_30 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "font-bold text-black" }, "Login with Metamask", -1))
const _hoisted_31 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "font-bold" }, "Login with Bring Back The Forest", -1))
const _hoisted_32 = { class: "text-center" }
const _hoisted_33 = /*#__PURE__*/_createTextVNode(" Not registered yet? ")
const _hoisted_34 = ["href"]
const _hoisted_35 = {
  key: 1,
  class: "container__login"
}
const _hoisted_36 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "modal__header" }, [
  /*#__PURE__*/_createElementVNode("h2", null, "Create an account")
], -1))
const _hoisted_37 = { key: 0 }
const _hoisted_38 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "mb-2" }, "Email", -1))
const _hoisted_39 = { key: 1 }
const _hoisted_40 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "mb-2" }, "Password", -1))
const _hoisted_41 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "mb-2" }, "Confirm password", -1))
const _hoisted_42 = /*#__PURE__*/_createTextVNode(" Create account ")
const _hoisted_43 = /*#__PURE__*/_createTextVNode(" Back to ")
const _hoisted_44 = {
  key: 2,
  class: "signup-news"
}
const _hoisted_45 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, [
  /*#__PURE__*/_createElementVNode("p", { class: "md:text-xl text-sm font-semibold mb-2" }, " Sign up for our newsletter "),
  /*#__PURE__*/_createElementVNode("p", { class: "md:text-base text-xs text-gray-description md:block hidden" }, " New teas, sales & promotions. "),
  /*#__PURE__*/_createElementVNode("p", { class: "md:text-base text-xs text-gray-description md:block hidden" }, " Be the first to know. ")
], -1))
const _hoisted_46 = { class: "flex md:ml-28 ml-6" }
const _hoisted_47 = /*#__PURE__*/_createTextVNode(" Sign up ")

import useToastMessage from '@/composables/useToastMessage';
import { useUserStore } from '@/store/user';
import { ref, reactive, computed, onMounted, onUnmounted } from 'vue';
import { Icon } from '@iconify/vue';
import { useRouter, useRoute } from 'vue-router';
import * as apis from '@/apis';
import * as apisForest from '@/apis/forest';
import { useToast } from 'vue-toastification';

import { useReCaptcha } from 'vue-recaptcha-v3';


export default /*#__PURE__*/_defineComponent({
  setup(__props) {

const { error } = useToastMessage();
const router = useRouter();
const route = useRoute();

const isReceiveLoginWithCenter = ref(false);
let isLogin = ref(true);
const emailNews = ref('');
const toast = useToast();
const { executeRecaptcha, recaptchaLoaded, instance } = useReCaptcha();

onMounted(() => {
  isLogin.value = !isReceiveSignup.value;
  if (instance.value) instance.value.showBadge();
});
onUnmounted(() => {
  if (instance.value) instance.value.hideBadge();
});

const recaptcha = async () => {
  // (optional) Wait until recaptcha has been loaded.
  await recaptchaLoaded();

  // Execute reCAPTCHA with action "login".
  const token = await executeRecaptcha('subscription');

  // Do stuff with the received token.
  const res = await apisForest.subscriptionNews({
    email: emailNews.value,
    re_captcha: token,
  });
  if (res.data.code === 200) {
    toast.success("You're subscribed. 🎉");
  } else {
    toast.error(res.data.message);
  }
  emailNews.value = '';
};

const toggleSignup = () => {
  isLogin.value = !isLogin.value;
};

const login = reactive({
  username: '',
  password: '',
});

const receive = reactive({
  send: '',
});
const authenticated = computed(() => !!userStore.value.me);
const userStore = computed(() => useUserStore());

const submitLogin = async (isWallet?: boolean) => {
  try {
    if (isWallet) await userStore.value.connectWallet();
    else await userStore.value.login(login.username, login.password);
    // emits('update:modelValue', false);
    if (isReceiveLogin.value) {
      const claimId =
        userStore.value.isGeneratedUser && authenticated.value
          ? localStorage.getItem('receive_id')
          : localStorage.getItem('receive_donate_id');
      router.push(`/landing/receive/${claimId}/login`);
    } else {
      router.go(-1);
    }
  } catch (err) {
    error(err);
  }
};

const newAccount = reactive({
  email: '',
  password: '',
});
const confirmPassword = ref('');
const isSignupInvalid = computed(() => {
  const unmatchedPassword = newAccount.password !== confirmPassword.value;
  return newAccount.password === '' || unmatchedPassword;
});
const createAccount = async () => {
  try {
    await userStore.value.signup(newAccount.email, newAccount.password);
    const link = `/landing/receive/${route.params.id}/sign-up`;
    if (isReceiveSignup.value) {
      await userStore.value.createWallet();
      localStorage.setItem('signUpForReceive', link);
    }
  } catch (err) {
    error(err);
  }
};
const isReceiveLogin = computed(() => {
  return route?.name === 'LoginReceivePage';
});

const isReceiveSignup = computed(() => {
  return route?.name === 'SignupReceivePage';
});

const submitSend = async () => {
  await apis.receiveSendByGuest({
    paymentId: route.params.id,
    recipient: receive.send,
  });

  router.push(`/landing/send-nft/${receive.send}/confirm`);
};

const metamaskInstalled = computed(() => {
  return typeof window.ethereum !== 'undefined';
});

return (_ctx: any,_cache: any) => {
  const _component_BaseInputText = _resolveComponent("BaseInputText")!
  const _component_router_link = _resolveComponent("router-link")!
  const _component_BaseButton = _resolveComponent("BaseButton")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_unref(isLogin))
      ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
          (!_unref(isReceiveLogin))
            ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
                _hoisted_4,
                _createElementVNode("form", {
                  class: "space-y-6 pb-4 container",
                  onSubmit: _cache[3] || (_cache[3] = _withModifiers(() => {}, ["prevent"])),
                  "data-testid": "form-auth"
                }, [
                  _createElementVNode("div", null, [
                    _hoisted_5,
                    _createVNode(_component_BaseInputText, {
                      modelValue: _unref(login).username,
                      "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_unref(login).username) = $event)),
                      "data-testid": "username-auth-input"
                    }, null, 8, ["modelValue"])
                  ]),
                  _createElementVNode("div", null, [
                    _hoisted_6,
                    _createVNode(_component_BaseInputText, {
                      modelValue: _unref(login).password,
                      "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_unref(login).password) = $event)),
                      type: "password",
                      "data-testid": "password-auth-input"
                    }, null, 8, ["modelValue"])
                  ]),
                  _createElementVNode("div", _hoisted_7, [
                    _createVNode(_component_router_link, {
                      to: "/forgot",
                      style: {"font-size":"14px","color":"#6d7380"},
                      "data-testid": "forgot-pass-word"
                    }, {
                      default: _withCtx(() => [
                        _hoisted_8
                      ]),
                      _: 1
                    })
                  ]),
                  _createVNode(_component_BaseButton, {
                    type: "submit",
                    "color-scheme": "primary-2",
                    full: "",
                    onClick: _cache[2] || (_cache[2] = ($event: any) => (submitLogin())),
                    "data-testid": "login-email-btn"
                  }, {
                    default: _withCtx(() => [
                      _hoisted_9
                    ]),
                    _: 1
                  }),
                  _createElementVNode("p", { class: "text-center" }, [
                    _hoisted_10,
                    _createElementVNode("a", {
                      role: "button",
                      class: "text-primary",
                      onClick: toggleSignup,
                      "data-testid": "create-account-btn"
                    }, " Create an account ")
                  ])
                ], 32),
                (_unref(metamaskInstalled))
                  ? (_openBlock(), _createElementBlock("div", _hoisted_11, [
                      _hoisted_12,
                      _createElementVNode("div", null, [
                        _createVNode(_component_BaseButton, {
                          "color-scheme": "white",
                          class: "border",
                          full: "",
                          onClick: _cache[4] || (_cache[4] = ($event: any) => (submitLogin(true))),
                          "data-testid": "login-metamast-btn"
                        }, {
                          default: _withCtx(() => [
                            _createVNode(_unref(Icon), {
                              class: "mr-3",
                              icon: "logos:metamask-icon"
                            }),
                            _hoisted_13
                          ]),
                          _: 1
                        })
                      ])
                    ]))
                  : _createCommentVNode("", true)
              ]))
            : (_openBlock(), _createElementBlock("div", _hoisted_14, [
                (isReceiveLoginWithCenter.value)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_15, [
                      _hoisted_16,
                      _createElementVNode("form", {
                        class: "space-y-6 pb-4",
                        onSubmit: _cache[8] || (_cache[8] = _withModifiers(() => {}, ["prevent"]))
                      }, [
                        _createElementVNode("div", null, [
                          _hoisted_17,
                          _createVNode(_component_BaseInputText, {
                            modelValue: _unref(login).username,
                            "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_unref(login).username) = $event)),
                            "data-testid": "email-login-receive-input"
                          }, null, 8, ["modelValue"])
                        ]),
                        _createElementVNode("div", null, [
                          _hoisted_18,
                          _createVNode(_component_BaseInputText, {
                            modelValue: _unref(login).password,
                            "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((_unref(login).password) = $event)),
                            type: "password",
                            "data-testid": "pass-login-receive-input"
                          }, null, 8, ["modelValue"])
                        ]),
                        _createVNode(_component_BaseButton, {
                          type: "submit",
                          "color-scheme": "primary-2",
                          full: "",
                          onClick: _cache[7] || (_cache[7] = ($event: any) => (submitLogin())),
                          "data-testid": "login-receive-btn"
                        }, {
                          default: _withCtx(() => [
                            _hoisted_19
                          ]),
                          _: 1
                        }),
                        _createElementVNode("p", { class: "text-center" }, [
                          _hoisted_20,
                          _createElementVNode("a", {
                            role: "button",
                            class: "text-primary",
                            onClick: toggleSignup,
                            "data-testid": "signup-btn"
                          }, " Create an account ")
                        ])
                      ], 32),
                      (_unref(metamaskInstalled))
                        ? (_openBlock(), _createElementBlock("div", _hoisted_21, [
                            _hoisted_22,
                            _createElementVNode("div", null, [
                              _createVNode(_component_BaseButton, {
                                "color-scheme": "white",
                                class: "border",
                                full: "",
                                onClick: _cache[9] || (_cache[9] = ($event: any) => (submitLogin(true))),
                                "data-testid": "login-metamask-receive-btn"
                              }, {
                                default: _withCtx(() => [
                                  _createVNode(_unref(Icon), {
                                    class: "mr-3",
                                    icon: "logos:metamask-icon"
                                  }),
                                  _hoisted_23
                                ]),
                                _: 1
                              })
                            ])
                          ]))
                        : _createCommentVNode("", true)
                    ]))
                  : (_openBlock(), _createElementBlock("div", _hoisted_24, [
                      _hoisted_25,
                      _createElementVNode("form", {
                        class: "space-y-6 pb-4",
                        onSubmit: _cache[12] || (_cache[12] = _withModifiers(() => {}, ["prevent"]))
                      }, [
                        _createElementVNode("div", null, [
                          _hoisted_26,
                          _createVNode(_component_BaseInputText, {
                            modelValue: _unref(receive).send,
                            "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event: any) => ((_unref(receive).send) = $event)),
                            placeholder: "Input wallet address",
                            "data-testid": "send-to-wallet-input"
                          }, null, 8, ["modelValue"])
                        ]),
                        _createVNode(_component_BaseButton, {
                          type: "submit",
                          "color-scheme": "primary",
                          full: "",
                          "data-testid": "send-to-wallet-btn",
                          onClick: _cache[11] || (_cache[11] = ($event: any) => (submitSend()))
                        }, {
                          default: _withCtx(() => [
                            _hoisted_27
                          ]),
                          _: 1
                        })
                      ], 32),
                      _hoisted_28,
                      _createElementVNode("div", _hoisted_29, [
                        (_unref(metamaskInstalled))
                          ? (_openBlock(), _createBlock(_component_BaseButton, {
                              key: 0,
                              "color-scheme": "white",
                              class: "border",
                              full: "",
                              onClick: _cache[13] || (_cache[13] = ($event: any) => (submitLogin(true))),
                              "data-testid": "login-metamask-btn"
                            }, {
                              default: _withCtx(() => [
                                _createVNode(_unref(Icon), {
                                  class: "mr-3",
                                  icon: "logos:metamask-icon"
                                }),
                                _hoisted_30
                              ]),
                              _: 1
                            }))
                          : _createCommentVNode("", true),
                        _createVNode(_component_BaseButton, {
                          "color-scheme": "border",
                          class: "border",
                          full: "",
                          onClick: _cache[14] || (_cache[14] = ($event: any) => (isReceiveLoginWithCenter.value = true)),
                          "data-testid": "login-email-btn"
                        }, {
                          default: _withCtx(() => [
                            _hoisted_31
                          ]),
                          _: 1
                        }),
                        _createElementVNode("div", null, [
                          _createElementVNode("p", _hoisted_32, [
                            _hoisted_33,
                            _createElementVNode("a", {
                              role: "button",
                              class: "text-primary",
                              href: `/landing/auth/signup/receive/${_unref(route).params.id}`,
                              "data-testid": "create-account"
                            }, " Create an account ", 8, _hoisted_34)
                          ])
                        ])
                      ])
                    ]))
              ]))
        ]))
      : (_openBlock(), _createElementBlock("div", _hoisted_35, [
          _hoisted_36,
          _createElementVNode("form", {
            onSubmit: _cache[18] || (_cache[18] = _withModifiers(() => {}, ["prevent"])),
            class: "space-y-6"
          }, [
            (_unref(newAccount))
              ? (_openBlock(), _createElementBlock("div", _hoisted_37, [
                  _hoisted_38,
                  _createVNode(_component_BaseInputText, {
                    modelValue: _unref(newAccount).email,
                    "onUpdate:modelValue": _cache[15] || (_cache[15] = ($event: any) => ((_unref(newAccount).email) = $event)),
                    "data-testid": "create-mail-input"
                  }, null, 8, ["modelValue"])
                ]))
              : _createCommentVNode("", true),
            (_unref(newAccount))
              ? (_openBlock(), _createElementBlock("div", _hoisted_39, [
                  _hoisted_40,
                  _createVNode(_component_BaseInputText, {
                    modelValue: _unref(newAccount).password,
                    "onUpdate:modelValue": _cache[16] || (_cache[16] = ($event: any) => ((_unref(newAccount).password) = $event)),
                    type: "password",
                    "data-testid": "create-pass-input"
                  }, null, 8, ["modelValue"])
                ]))
              : _createCommentVNode("", true),
            _createElementVNode("div", null, [
              _hoisted_41,
              _createVNode(_component_BaseInputText, {
                modelValue: confirmPassword.value,
                "onUpdate:modelValue": _cache[17] || (_cache[17] = ($event: any) => ((confirmPassword).value = $event)),
                type: "password",
                "data-testid": "create-confirm-pass-input"
              }, null, 8, ["modelValue"])
            ]),
            _createVNode(_component_BaseButton, {
              type: "submit",
              full: "",
              "color-scheme": "primary",
              disabled: _unref(isSignupInvalid),
              onClick: createAccount,
              "data-testid": "create-confirm-btn"
            }, {
              default: _withCtx(() => [
                _hoisted_42
              ]),
              _: 1
            }, 8, ["disabled"]),
            _createElementVNode("p", { class: "text-center" }, [
              _hoisted_43,
              _createElementVNode("a", {
                role: "button",
                class: "text-primary",
                onClick: toggleSignup,
                "data-testid": "back-to-login-btn"
              }, " log in ")
            ])
          ], 32)
        ])),
    (_unref(isLogin))
      ? (_openBlock(), _createElementBlock("div", _hoisted_44, [
          _hoisted_45,
          _createElementVNode("div", _hoisted_46, [
            _createVNode(_component_BaseInputText, {
              modelValue: emailNews.value,
              "onUpdate:modelValue": _cache[19] || (_cache[19] = ($event: any) => ((emailNews).value = $event)),
              placeholder: "Email",
              style: {"max-width":"330px"},
              class: "bg-white w-full",
              "data-testid": "email-news-input"
            }, null, 8, ["modelValue"]),
            _createVNode(_component_BaseButton, {
              class: "ml-6",
              type: "submit",
              full: "",
              style: {"width":"95px"},
              "color-scheme": "primary-2",
              "data-testid": "signup-news-btn",
              onClick: recaptcha
            }, {
              default: _withCtx(() => [
                _hoisted_47
              ]),
              _: 1
            })
          ])
        ]))
      : _createCommentVNode("", true)
  ]))
}
}

})